import React, { useState } from "react";
import { toast } from "react-hot-toast";
import {
  CreateStateService,
  CreateStatePayload,
} from "../Services/APIService";

interface CreateCardProps {
  onCreateComplete: () => void;
  onCancel: () => void;
}

interface FormData {
  stateName: string;
}

const CreateStateCard: React.FC<CreateCardProps> = ({
  onCreateComplete,
  onCancel,
}) => {
  const [formData, setFormData] = useState<FormData>({ stateName: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const requiredField = <span className="text-danger ms-1">*</span>;

  const handleStateNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, stateName: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!formData.stateName.trim()) {
      setError("Please enter a valid State Name");
      return;
    }

    const userId = localStorage.getItem("UserId");
    if (!userId) {
      setError("User ID not found. Please log in again.");
      return;
    }

    const payload: CreateStatePayload = {
      stateName: formData.stateName.trim().replace(/\s+/g, " "),
      createdBy: parseInt(userId),
    };

    try {
      setIsLoading(true);
      const result = await CreateStateService(payload);

      if (result.isCreated) {
        toast.success(result.message || "State Created Successfully!");
        setFormData({ stateName: "" });
        onCreateComplete();
      } else {
        throw new Error(result.message || "Failed to create state");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({ stateName: "" });
    setError(null);
    onCancel();
  };

  return (
    <div className="card mb-4">
      <div className="card-header carHeaderWithBtn">
        <h5 className="card-title mb-0">Create State</h5>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="alert alert-danger text-danger" role="alert">
              {error}
            </div>
          )}
          <div className="row">
            <div className="col-12 col-lg-4 mb-3">
              <label htmlFor="stateName" className="form-label">
                State Name{requiredField}
              </label>
              <input
                type="text"
                id="stateName"
                name="stateName"
                className="form-control form-control-lg"
                placeholder="Enter State Name"
                value={formData.stateName}
                onChange={handleStateNameChange}
                required
              />
            </div>
            <div className="col-12">
              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={isLoading}
              >
                {isLoading ? "Creating..." : "Submit"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateStateCard;